import React from "react";

export default function OrnamentalDivider({ className = "" }) {
    return (
        <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
            <span className="h-px w-16 bg-gradient-to-r from-transparent via-gold to-transparent" />
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                    d="M14 2 L17 11 L26 14 L17 17 L14 26 L11 17 L2 14 L11 11 Z"
                    fill="none"
                    stroke="#B58A43"
                    strokeWidth="1"
                />
                <circle cx="14" cy="14" r="2.6" fill="#B58A43" />
            </svg>
            <span className="h-px w-16 bg-gradient-to-r from-transparent via-gold to-transparent" />
        </div>
    );
}
